<template>
    <div id="resume">
        <v-layout row wrap>
            <v-flex xs12 sm6 pr-3>
            
            <v-card>
                <v-card-text>
                    <h3 class="title my-4">Education:</h3>
                        <ul>
                            <li>2001 - Bachelor's Degree in "Classic Voice"; status of "Artist-Vocalist". 
                                <br>Diploma with honors (Stanislav Ludkevich College of Music of Ukraine, Lviv)</li>
                            <li>2006 - Master's Degree in Theater; status of Actress of Drama Theater and Cinema. <br> 
                                Diploma with honors (Ivan Franko National University of Ukraine, Lviv)</li>
                        </ul>                    
                </v-card-text>
            </v-card>


<v-card class="mt-2">
    <v-card-text>
        <h3 class="title my-4">Professional Experience:</h3>
            <p>2019 - current Owner, Voice and Stage Drama Instructor of Coach Performing Arts Academy (Charlotte, NC, USA)</p>
            <!-- <p>2019-current - Stage Drama and Voice Instructor of Charlotte Film School (Charlotte, NC, USA)</p> -->
            <p>2018-2019 - Stage Drama and Voice Instructor of Virtuoso School of Music and Art & Dance (Ballantyne, NC, USA)</p>
            <p>2009-current - Free-lance Performing Artis</p>
            <p>2014-2016 - organizer and Performer of solo theatrical/musical concerts (Ukraine)</p>
                <ul>
                    <li>Performer in a series of concerts dedicated to the works of famous Ukrainian writers Ivan Franko and Taras Shevchenko</li>
                    <li>Actress, singer, theatrical director  in a series of concerts "Heroes Do not Die!" at Lviv National Academic Philharmonic</li>
                    <li>A series of own concert programs "My Word is the only weapon", "Rhone", concert to "144th anniversary of the birth of Lesya Ukrainka", concert recital "Poetry of Vasyl Symonenko", concert recital "Poetry by Lina Kostenko" and others in Kyiv Ukraine</li>
                    <li>Musical and theatrical performance "8 Women" at  Theater  "Stars", (Kyiv Ukraine )</li>
                </ul>

            <p>2012-2013 - participant in Vocal-Theatrical concerts in the St. Sofia Cathedral Hal</p>
            <p>2012 - actress-Opera Studio of National Musical Academy of Petro Tchaikovsky (Kyiv, Ukraine)</p>
                <ul>
                    <li>Main role of Maria in the comical opera "Count Caliostro" (by M. L. Taliverdieva)</li>
                </ul>

            <p>2003-2010 - theater Actress- Academic Theater "Voskresinnya" (Lviv, Ukraine)</p>
                <ul>
                    <li>Main role of "Mavka" in the Musical Drama "In My Heart I Have That, What Cannot Die" (by Lesya Ukrainka)</li>
                    <li>Main role of "The Doctor"; Role of "Titch" in the support line up in the drama "The Colonel and the Birds" (by Chrzystos Bochev)</li>
                    <li>Role of "Valentine's Teacher" in the drama "Tomorrow, There Was a War" (by Borys Vasylev)</li>
                </ul>

            <p>2006-2007 - Contracted Actress  - Theater "Miror" (Kyiv, Ukraine)</p>
            <ul>
                <li>Main role of the Snow Princess in the Musical drama "A Christmas Journey”</li>
                <li>Role of the "Nanny" in the drama "Viy" (by Mykola Gogol)</li>
            </ul>

            <p>2008 - radio Journalist / Host  in "Renown Persons" talk show (Ukrainian National Communications Radio in Kyiv)</p>
            <p>2007-2008 - radio Host "Melodia Radio" and "Sharmanka" (Kyiv, Ukraine)</p>
    </v-card-text>
</v-card>

<v-card class="mt-2">
    <v-card-text> 
        <h3 class="title my-4">Cinema castings:</h3>
        <ul>
            <li>Main role of Ludmilla in the Documentary Film "Personal Matters" Inter Broadcasting (Kyiv, Ukraine)</li>
            <li>Main role of Mavka in the Musical Drama "Forest Song" (Lviv, Ukraine)</li>
            <li>Supporting role in the serial episode "Archbishop Andrey" (Director O. Yanchuk)</li>
            <li>Miscellaneous television commercials</li>
        </ul>
    </v-card-text>
</v-card>

    </v-flex>
    <v-flex xs12 sm6>
        <h3>A Lesia Ukrainka drama "Lisova Pisnya" or "Forest Song"; monologue "A Wood Nymph's life story".</h3>
            <p class="font-style-italic">Performed by Oksana Kowcz.<br>
                                             Recorded at "Videostudio A. T.". Lviv, 2013</p>
                <iframe width="100%" height="350" src="//www.youtube.com/embed/fFjvHTeRxIQ" frameborder="0" allowfullscreen=""></iframe>
            <v-card>
                <v-card-title>
                    <div class="title mt-4">STUDIO CONTACT INFORMATION:</div>
                </v-card-title>
                <v-card-text>
                    <v-layout row wrap class="mb-4">
                        <v-flex xs12 sm6>
                            <h2 class="studio success--text ">"Videostudio A. T."</h2>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <h2 class="mt-14"><a href="http://www.hlynskyi.com.ua/" target="_blank">Website</a></h2>
                        </v-flex>
                    </v-layout>   
                </v-card-text>
            </v-card>

    <v-card class="mt-2">
        <v-card-text> 
             <h3 class="title my-4">Professional Accomplishments:</h3>
        <ul>
            
            <li>2015 - Medal of Honor for Sacrifice аnd Love for Ukraine, for contributions to Ukrainian Culture</li>
            <li>2009 - Laureate Grand  Prize Winner in the Taras Shevchenko All Ukrainian Recital and Orator's Competition</li>
                <li>2007 - Main role of "Mavka" in the Musical Drama "In my heart I have that, what cannot die" in the International competition "Neighbors" (Poland). Ranked in the top five best performances of the competition</li>
                <li>2006 - First Place, Gold medalist in the "Arts Competition of Lviv-750</li>
                <li>2005 - Participant in the International Theater Festival "Podium-2005" in Moscow, Russia</li>
            </ul>            
        </v-card-text>
    </v-card>       
    
    <v-card class="mt-2">
        <v-card-text> 
            <h3 class="title my-4">Developing talented children</h3>
                <p>2007-2009, 2015 - Honorary Guest, Theater Voice Coach, Judge in the Annual Literary Arts Festival "The Pereyaslav Autumn of the Kobzar".</p>
                <p>2016 - President of Judge's Panel at the Lesia Ukrainka Recital Competition (Kyiv, Ukraine). President of the Judge's Panel Maksym Rylskiy Recital Competition (Kyiv, Ukraine)</p>  
                <p>"…it is most satisfying when I can teach children, develop their acting and voice skills, and witness them achieving new heights with every performance!"</p>
                <p>Oksana Kowcz</p>            
        </v-card-text>
    </v-card>   

    <v-card class="mt-2">
        <v-card-text> 
            <h3 class="title my-4">Summary of Skills:</h3>        
            <ul>
                <li>Ability to perform songs in different languages;  perform opera arias in Italian, Czech and Polish</li>
                <li>Excellent memorization skills in roles and music</li>
                <li>Exciting entertainer and dynamic performer</li>
                <li>Piano playing skills at intermediate level</li>
                <li>Excellent communication and organizational skills</li>
                <li>Exceptional ability to create new singing and acting methods that keep students interested and involved</li>
                <li>Excellent ability to work well with children and adults</li>
            </ul>            
        </v-card-text>
    </v-card>   
                <v-card class="mt-2 pb-63">
                    <v-card-text> 
                        <h3 class="title my-4">Languages:</h3>
                        <ul>
                            <li>Ukrainian (native)</li>
                            <li>Russian</li>
                            <li>English </li>
                        </ul>            
                    </v-card-text>
                </v-card>   
            </v-flex>            
        </v-layout>
    </div>
</template>

<script>
    export default {
        name: 'Resume_EN',
        data: () => ({

        })
    }
</script>

<style>
    .mt-14 {
        margin-top: 14px;
    }
    .pb-63 {
        padding-bottom: 63px;
    }
</style>



